import { IValidationMessage } from '../../../models/validation-message.interface';

const panValidationMessageList: IValidationMessage[] = [
    {
        error: 'required',
        message: 'Пожалуйста, введите номер карты'
    },
    {
        error: 'incorrectCardRange',
        message: 'Пожалуйста, введите номер карты платежной системы «МИР»'
    },
    {
        error: 'incorrectCardNumber',
        message: 'Пожалуйста, введите корректный номер карты'
    },
    {
        error: 'mask',
        message: 'Пожалуйста, введите корректный номер карты'
    }
];

export default panValidationMessageList;
